import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { Cell, flexRender, Row } from "react-table-8.10.7";
import { Task } from "types/Models/task";

type ServiceRowData = Task & { isLast?: boolean; subRows?: Task[] };

type MobileServiceRowProps = {
  row: Row<ServiceRowData>;
  onRowClick: (taskId: string) => void;
};

// Column ids set on the column helpers in ServicesTable.
const SERVICE_COLUMN_ID = {
  NAME: "title",
  DESCRIPTION: "display_text",
  STATUS: "status",
} as const;

const renderCell = (cell?: Cell<ServiceRowData, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileServiceRow = ({
  row,
  onRowClick,
}: MobileServiceRowProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );

  const handleClick = () => onRowClick(row.original.uuid);

  return (
    <div className="t-border-0 t-border-b t-border-solid t-border-neutral-0 t-py-3 last:t-border-b-0">
      <Button
        type="button"
        customType="ghost"
        onClick={handleClick}
        className="t-w-full !t-h-auto !t-px-0 !t-whitespace-normal t-text-left [&>div]:t-w-full [&>div]:t-justify-start [&>div>div]:t-w-full [&>div>div]:t-justify-start"
      >
        <div className="t-flex t-flex-col t-gap-1 t-w-full">
          <div className="t-flex t-items-start t-justify-between t-gap-3">
            <div className="t-min-w-0">
              {renderCell(cellsById[SERVICE_COLUMN_ID.NAME])}
            </div>
            <div className="t-shrink-0">
              {renderCell(cellsById[SERVICE_COLUMN_ID.STATUS])}
            </div>
          </div>
          <div
            className={classNames("t-text-text-30", {
              "t-pl-1": row.depth === 0,
              "t-pl-8": row.depth > 0,
            })}
          >
            {renderCell(cellsById[SERVICE_COLUMN_ID.DESCRIPTION])}
          </div>
        </div>
      </Button>
    </div>
  );
};
